<script setup lang="ts">
defineProps({
  search: null
})

const { addSearchesToSidebar, removeSearchesFromSidebar, sidebarFavoriteSearches } = useSidebar()
</script>

<template>
  <div>
    <menu-section>
      <dropdown-item
        v-if="!!sidebarFavoriteSearches[search.id]"
        @click="removeSearchesFromSidebar({ [search.id]: search })"
      >
        <template #icon>
          <icon-action size="xs" type="unpin" />
        </template>
        <template #default>
          <div>Remove favorite</div>
        </template>
      </dropdown-item>
      <dropdown-item
        v-else
        @click="addSearchesToSidebar({ [search.id]: search })"
      >
        <template #icon>
          <icon-action size="xs" type="pin" />
        </template>
        <template #default>
          <div>Add to favorites</div>
        </template>
      </dropdown-item>
    </menu-section>
  </div>
</template>
